export const COMPANY_ACTIVATION_STEPPER_NAMESPACE = 'company-activation';

export enum COMPANY_ACTIVATION_STEPS {
  INITIAL_STEP = 'initial-step',
  MAIL_CODE_VERIFICATION = 'mail-code-verification',
  SMS_OTP_VERIFICATION = 'sms-otp-verification',
  ACTIVATION_SUCCESS = 'activation-success',
}
